import React, { useState } from 'react';
import { Sliders, ChevronDown, ChevronUp } from 'lucide-react';
import countriesData from '../utils/countries.json';
import './AdvancedSettings.css';

function AdvancedSettings({ values = {}, onChange }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const { turbo = false, geolocation = '', strict = true } = values;

    const handleTurboChange = (e) => {
        onChange({
            ...values,
            turbo: e.target.checked
        });
    };

    const handleStrictChange = (e) => {
        onChange({
            ...values,
            strict: e.target.checked
        });
    };

    const handleGeolocationChange = (e) => {
        onChange({
            ...values,
            geolocation: e.target.value || null
        });
    };

    return (
        <div className={`advanced-settings-wrapper ${isExpanded ? 'expanded' : ''}`}>
            <button 
                type="button" 
                className="advanced-settings-header"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div className="header-title">
                    <Sliders size={16} />
                    <span>Advanced Execution Settings</span>
                </div>
                {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>

            {isExpanded && (
                <div className="advanced-settings-body">
                    <div className="advanced-settings-option">
                        <label className="option-checkbox-label">
                            <input
                                type="checkbox"
                                checked={turbo}
                                onChange={handleTurboChange}
                            />
                            <div className="option-text-group">
                                <span className="option-title">Enable Turbo Mode</span>
                                <span className="option-description">
                                    Enables action sequence generation to run multiple steps at once (faster execution).
                                </span>
                            </div>
                        </label>
                    </div>

                    <div className="advanced-settings-option">
                        <label className="option-checkbox-label">
                            <input
                                type="checkbox"
                                checked={strict}
                                onChange={handleStrictChange}
                            />
                            <div className="option-text-group">
                                <span className="option-title">Strict Guidelines</span>
                                <span className="option-description">
                                    Injects detailed heuristics for scrolling, element strategy fallback, coordinate estimation, and relative targeting.
                                </span>
                            </div>
                        </label>
                    </div>

                    <div className="advanced-settings-option">
                        <div className="option-select-group">
                            <label htmlFor="country-select" className="option-label">
                                Launch Geolocation (Country)
                            </label>
                            <select
                                id="country-select"
                                className="option-select-dropdown"
                                value={geolocation || ''}
                                onChange={handleGeolocationChange}
                            >
                                <option value="">Default (Auto / Local)</option>
                                {Object.entries(countriesData)
                                    .sort((a, b) => a[1].name.localeCompare(b[1].name))
                                    .map(([code, c]) => (
                                        <option key={code} value={code}>
                                            {c.name} ({code})
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdvancedSettings;
